var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#fff;}.c{filter:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.394,
    y1: -0.248,
    x2: 0.244,
    y2: 1.362,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9100ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b00ff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 0,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#6a00ff",
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1551.5 -608.5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, 1551.5, 608.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 38,
    height: 38,
    rx: 19,
    transform: "translate(30 20)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.5,18.963V22.77H8.306L19.533,11.543,15.726,7.737ZM22.476,8.6a1.011,1.011,0,0,0,0-1.431L20.1,4.793a1.011,1.011,0,0,0-1.431,0L16.812,6.651l3.806,3.806Z",
    transform: "translate(1587.23 633.504)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/edit-button.3b81b5a127f817fe4a7878dce4ba7daf.svg";
export { ForwardRef as ReactComponent };